import { Select, MenuItem, FormControl } from "@mui/material";
import React from "react";

type Option = {
  value: string | number;
  label: string;
};

type SmallSelectProps = React.ComponentProps<typeof Select> & {
  options: Option[];
  placeholder?: string;
};

export default function SmallSelect({
  options = [],
  placeholder = "Todos",
  value,
  ...props
}: SmallSelectProps) {
  return (
    <FormControl fullWidth>
      <Select
        {...props}
        value={value}
        displayEmpty
        renderValue={(selected): React.ReactNode => {
          if (selected === "" || selected === undefined) {
            return (
              <span style={{ color: "#888", fontSize: 12 }}>
                {placeholder}
              </span>
            );
          }

          const option = options.find((o) => o.value === selected);

          return option ? option.label : String(selected);
        }}

        sx={{
          "& .MuiOutlinedInput-root": {
            height: 38,
            borderRadius: "10px",
          },
          "& .MuiInputBase-input": {
            padding: "6px 12px",
            fontSize: "12px",
          },
          borderRadius: "10px",
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              "& .MuiMenuItem-root": {
                fontSize: "12px",
                py: 0.8,
              },
            },
          },
        }}
      >
        {options.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
